(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text-overlay-v2"] && !Shopify.designMode) return;
  try {
    
  console.log('listen to shopify theme editor re-render');
  function showAlert() {
    console.log('listen to shopify theme editor re-render');
  }

  document.addEventListener("shopify:section:load", showAlert);

  } catch(e) { console.error(e); }
})();
})();
